import { baseGet } from './internalGet';

export function get(obj: object, path: string, defaultValue?: any): any {
  const value = baseGet(obj, path).value;
  return value === undefined ? defaultValue : value;
}
